var CSSCONSTANTS = CSSCONSTANTS || {};

(function () {
	/* only used by providerList.js */
	CSSCONSTANTS.providerListClass = 'provider-list';
	CSSCONSTANTS.providerListMoreLinkClass = 'provider-list-more-link';
	CSSCONSTANTS.providersClass = 'provider-list__provider';
	CSSCONSTANTS.hiddenProvidersClass = 'provider-list__provider--hidden';
	CSSCONSTANTS.visibleProvidersClass = 'provider-list__provider--visible';
	CSSCONSTANTS.providerFilterClass = 'js-provider-list-filter';
	CSSCONSTANTS.providerFilterShowAllClass = 'js-provider-list-show-all';

	/* only used by transactionalLandingPageHero.js */
	CSSCONSTANTS.transactionalLandingPageHeroClass = 'hero--transactional-landing';
	CSSCONSTANTS.transactionalLandingPageHeroHeadingClass = 'hero--transactional-landing__heading';
	CSSCONSTANTS.transactionalLandingPageHeroImageClass = 'hero--transactional-landing__image';
	CSSCONSTANTS.transactionalLandingPageHeroActionClass = 'hero--transactional-landing__action';
	CSSCONSTANTS.transactionalLandingPageHeroSpeechClass = 'hero--transactional-landing__speech';

	CSSCONSTANTS.reminderBoxClass = 'box--reminder';

	/* only used by searchResultsHero.js */
	CSSCONSTANTS.heroHelpContactClass = 'hero--help__contact';
	CSSCONSTANTS.helpContactClass = 'help-contact';

	/* only used by productDrivers.js */
	CSSCONSTANTS.productDriverClass = 'product-driver';
	CSSCONSTANTS.productDriverImageClass = 'product-driver__image';
	CSSCONSTANTS.productDriverNotesClass = 'product-driver__notes';
	CSSCONSTANTS.productDriverLinkClass = 'product-driver__link';

	/* used by responsiveTabs.js */
	CSSCONSTANTS.responsiveTabsWrapperClass = 'responsive-tabs-wrapper';
	CSSCONSTANTS.responsiveTabsClass = 'responsive-tabs';
	CSSCONSTANTS.responsiveTabsEnabledClass = 'responsive-tabs--enabled';
	CSSCONSTANTS.responsiveTabsHeadingClass = 'responsive-tabs__heading';
	CSSCONSTANTS.responsiveTabsHeadingActiveClass = 'responsive-tabs__heading--active';
	CSSCONSTANTS.responsiveTabsPanelClass = 'responsive-tabs__panel';
	CSSCONSTANTS.responsiveTabsPanelActiveClass = 'responsive-tabs__panel--active';
	CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass = 'responsive-tabs__panel--closed-accordion-only';
	CSSCONSTANTS.responsiveTabsListClass = 'responsive-tabs__list';
	CSSCONSTANTS.responsiveTabsListItemClass = 'responsive-tabs__list__item';
	CSSCONSTANTS.responsiveTabsListItemActiveClass = 'responsive-tabs__list__item--active';
	CSSCONSTANTS.responsiveTabsStepsClass = 'responsive-tabs--steps';
})();
